<button type="button" (click)="handleClick($event)" (keydown.enter)="handleClick($event)" class="card">
  <div class="left-elements">
    <div class="asset-name">{{entityAsset().name}}</div>
    <div class="details">
      @if (entityAsset().type) {
        <div class="asset-type">{{entityAsset().type}}</div>
      }
      @if (!entityAsset().type) {
        <div class="asset-type fallback-text">(Empty)</div>
      }
      @if (entityAsset().marketValueCurrency) {
        <div class="asset-currency">{{entityAsset().marketValueCurrency}}</div>
      }
      @if (!entityAsset().marketValueCurrency) {
        <div class="asset-currency fallback-text">(Empty)</div>
      }
    </div>
  </div>
  <div class="right-elements">
    <div class="asset-marketvalue">{{entityAsset().marketValue.displayValue}}</div>
  </div>
</button>
